import React, { useEffect, useState } from "react";
import SingleSlider from "./SingleSlider";
import "./createSurvey.css";
import Navbar from "../../components/navbar/Navbar";
import Steps from "../../components/steps/Index";
import { Button, CircularProgress, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/navbar/Footer";
import { useSelector, useDispatch } from "react-redux";
import { updateAnswer } from "../../redux/slices/questionsSlice";
import useSurveyAutosave from "../../hooks/useSurveyAutosave";
import NavigationHintBox from "../../components/NavigationHintBox";
// import SurveyLinkBox from "../../components/SurveyLinkBox";

export default function Step15() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const answers = useSelector((state) => state.questions.answers);
  const { areas } = useSelector((state) => state.areas);
  const questions = useSelector((state) => state.questions?.questions);
  const companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
  const [companyName, setCompanyName] = useState(companyDetails?.companyName);
  // const [email, setEmail] = useState(companyDetails?.email);
  const [logo, setLogo] = useState(companyDetails?.logo);
  const [loading, setLoading] = useState(false);
  const { saveSurveyProgress } = useSurveyAutosave();
  const managerSurvey = localStorage.getItem("managerSurvey");
  const startIndex = 70;
  const pageQuestions = questions.slice(startIndex, startIndex + 5);
  // default answers
  useEffect(() => {
    pageQuestions?.forEach((question) => {
      const question_id = `q${question.id}`;
      if (!answers[question_id]) {
        // const options = [45, 55, 65];
        // const randomValue = options[Math.floor(Math.random() * options.length)];
        dispatch(updateAnswer({ questionId: question_id, answer: 0 }));
      }
    });
  }, [pageQuestions, answers, dispatch]);

  const handleAnswerChange = (data) => {
    const questionId = data.id;
    const answer = data.value;
    const answerKey = `q${questionId}`;
    dispatch(updateAnswer({ questionId: answerKey, answer: answer }));
  };

  const handlePrevClick = () => {
    dispatch({ type: "STEP" });
    localStorage.setItem(
      "companyDetails",
      JSON.stringify({ companyName, logo })
    );
    navigate("/step14");
  };

  const handleNextClick = async () => {
    if (!companyName && managerSurvey == "") {
      alert("Please enter the company name");
      return;
    }
    localStorage.setItem(
      "companyDetails",
      JSON.stringify({ companyName, logo })
    );
    setLoading(true);
    try {
      const response = await saveSurveyProgress(answers);
      if (response) {
        dispatch({ type: "STEP" });
        navigate("/result", {
          state: response,
        });
      } else {
        alert("Failed to save progress.");
      }
    } catch (error) {
      console.error("Error saving survey:", error);
      alert("An error occurred while saving.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <Navbar />
      <div className="mainContainer" style={{ flex: 1 }}>
        <NavigationHintBox />
        <div className="surveys-sub-container">
          <Steps step={15} active={true} />
          <div className="inst-c">
            {/* <SurveyLinkBox /> */}
            <div className="survey-slider-container-title surveys-question-title">
              Working Practices
            </div>
          </div>
          <div className="survey-slider-container inst-sub-first">
            <div className="slider-all">
              {pageQuestions?.map((question, index) => (
                <SingleSlider
                  key={question.id}
                  index={startIndex + index + 4} // start index is increment by 3 (new)
                  question={question}
                  pageQuestions={pageQuestions}
                  handleAnswerChange={handleAnswerChange}
                  currentAnswer={answers[`q${question.id}`] || 0}
                />
              ))}
            </div>
            {/* input fields for companyName and logo */}
            {managerSurvey == "" && (
              <div
                className="input-container"
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "20px",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <TextField
                    label="Company Name"
                    placeholder="Please enter your company name"
                    variant="outlined"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      width: "100%",
                      backgroundColor: "#f9f9f9",
                      borderRadius: "8px",
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#3F9BFD",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#3F9BFD",
                      },
                    }}
                  />
                  {/* <TextField
                  label="Email"
                  placeholder="Please enter your email"
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    width: "100%",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "8px",
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#3F9BFD",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#3F9BFD",
                    },
                  }}
                /> */}

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Button
                      component="label"
                      variant="contained"
                      sx={{
                        backgroundColor: "#3F9BFD",
                        color: "white",
                        textTransform: "capitalize",
                        padding: "10px 24px",
                        borderRadius: "8px",
                        fontWeight: "500",
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                        "&:hover": {
                          backgroundColor: "#3388cc",
                        },
                      }}
                    >
                      Upload Logo
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => setLogo(e.target.files[0])}
                      />
                    </Button>

                    {logo && (
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#555",
                          maxWidth: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {logo.name}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* buttons */}
          <div className="btn-container gap-5">
            <Button
              onClick={handlePrevClick}
              className="signupCVbtnSign"
              variant="contained"
              sx={{
                fontSize: "16px",
                fontWeight: 500,
                padding: "8px 30px",
                textTransform: "capitalize",
                borderRadius: "999px",
                backgroundColor: "#3F9BFD",
                "&:hover": { backgroundColor: "#3F9BFD" },
              }}
              disabled
            >
              Back
            </Button>
            <Button
              onClick={handleNextClick}
              className="signupCVbtnSign"
              type="submit"
              variant="contained"
              style={{
                backgroundColor: "#3F9BFD",
              }}
              sx={{
                fontSize: "16px",
                fontWeight: 500,
                padding: "8px 30px",
                borderRadius: "999px",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#3F9BFD",
                },
              }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
